import * as React from 'react';
import GuidanceEditor from './guidance/GuidanceEditor';
const RevisedGuidancePopup = ({ data, hasOverride, save }) => (React.createElement(GuidanceEditor, { initialGuidance: data?.override?.revisedGuidance ?? data?.data?.revisedGuidance, data: data, hasOverride: hasOverride, save: save }));
export default RevisedGuidancePopup;
